import { type AxiosRequestConfig } from 'axios'

const getEventParticipation = (id?: string): AxiosRequestConfig => {
  return {
    method: 'GET',
    url: `/event/${id}/participation`
  }
}

export { getEventParticipation }
